module.exports = __webpack_public_path__ + "img/img_lianghua_hezuo@3x.d71601ee.png";